export default __webpack_public_path__ + "static/1689-10a9c099e703ed4d4c93158f413144de.jpeg";